import { SYNC_WORK_DATA } from '@src/type/workData';

export const syncWorkData = useData => ({
  type: SYNC_WORK_DATA,
  useData,
});
